import { EventErrorType } from '@/entities/Object'

export const ErrorsTypes = new Map<
  string,
  {
    icon: string
    event_type: EventErrorType
    tooltip: string
    text?: string
  }
>(
  Object.entries({
    circuits: {
      icon: 'conversion_path_off',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.circuits',
    },
    contactors: {
      icon: 'hide_source',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.circuits',
    },
    door_open: {
      icon: 'lock_open',
      event_type: EventErrorType.WARNING,
      tooltip: 'itf.statuses.door_open',
    },
    el_params: {
      icon: 'electric_bolt',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.el_params',
    },
    fire: {
      icon: 'local_fire_department',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.fire',
    },
    frequent_reboot: {
      icon: 'rotate_auto',
      event_type: EventErrorType.WARNING,
      tooltip: 'itf.statuses.frequent_reboot',
    },
    long_offline: {
      icon: 'signal_disconnected',
      event_type: EventErrorType.WARNING,
      tooltip: 'itf.statuses.long_offline',
    },
    main_circuit_breaker: {
      icon: 'shield',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.input_control_off',
    },
    meter_offline: {
      icon: 'crop_square',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.meter_is_not_connect',
      text: 'wh',
    },
    outgoing_circuit_breakers: {
      icon: 'shield',
      event_type: EventErrorType.ERROR,
      tooltip: 'itf.statuses.output_control',
      text: 'o',
    },
    schedule_not_synced: {
      icon: 'event_busy',
      event_type: EventErrorType.WARNING,
      tooltip: 'itf.statuses.schedule_not_synchro',
    },
    settings_not_synced: {
      icon: 'reset_wrench',
      event_type: EventErrorType.WARNING,
      tooltip: 'itf.statuses.settings_not_synchro',
    },
  }),
)
